import React from 'react'
import WeischerItem from './WeischerItem'

const WeischerItemsList = ({weischerAdsList}) => (
    weischerAdsList.length > 0 && <div className={"grid-site-wrapper weischer items-count-" + weischerAdsList.length}>
        {weischerAdsList.map((item, index) => <WeischerItem
            key={index} 
            wrapperClassName="weischer-item-wrapper"
            itemClassName="weischer-item"
            item={item}
        />)}
    </div>
)

export default WeischerItemsList